import { Box, BoxProps, Skeleton } from "@mui/material";
import React from "react";

export interface GroupMemberSkeletonProps extends BoxProps {}

export function GroupMemberSkeleton(props: GroupMemberSkeletonProps) {
  return (
    <Box
      {...props}
      sx={[
        {
          display: "flex",
          alignItems: "center",
          gap: 3,
          py: 2,
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    >
      <Skeleton variant="rounded" width={56} height={56} />
      <Box>
        <Skeleton width={200} height={18} />
        <Skeleton width={150} height={18} />
      </Box>
    </Box>
  );
}
